import { createSlice } from "@reduxjs/toolkit";
const initialBasicSettingsState = {
  actionsLoading: true,
  devicesListLoading: false,
  dragcolumnlisting: [],
  catalogProductColumnOrder: [],
  importLoading: false,
  images: "",
  message: {
    error: null,
    success: null,
  },
  lastError: null,
  entity: {
    MSA: {
      eow: "",
      dist_id_num: "",
      proj_id_num: "",
      test_or_live: "",
      interval: "",
      dist_name: "",
      dist_addr: "",
      dist_city: "",
      dist_state: "",
      dist_zipcode: "",
      dist_country: "",
      dist_cont_ln: "",
      dist_cont_fn: "",
      dist_cont_tel: "",
      dist_cont_fax: "",
      dist_cont_email: "",
      no_of_measured_bid: "",
      no_of_measured_sid: "",
      no_of_measured_pur: "",
      inv_resub_flag: "",
    },
    Shipment: {
      send_shipment_notification: false,
      shipment_carriers: [],
    },
    Devices: {
      totalCount:0,
      devicesListing:[],
    },
    DELIVERY: {
      enable_delivery_module: false, 
      address_verification: false, 
      khub_terms_verification: false
    },
    SHIPPING: {
      default_warehouse: "",
      display_units: "imperial",
      parcel_available: true,
      ltl_available: true,
      ltl_weight_threshold: 150,
      default_billing: "prepaid"
    },
    Basic: {
      licence_expiry_threshold: 30,
      account_title: "",
      website: "",
      logo: "",
      forget_pass_subj: "",
      forget_pass_html: "",
      currency_symbol: "",
      currency_type: "",
      tenant_invoice_logo: "",
      invoice_promotion_banner:""
    },
    Invoice: {
      order_details: {
        Invoice_no: true,
        Invoice_date: true,
        Order_type: true,
        Order_by: true,
        cashier_name: true,
        sale_agent_name: true,
        Order_date: true,
        Payment_type: true,
        Payment_date: true,
      },
      customer_details: {
        Business_name: true,
        Person_name: true,
        Phone: true,
        Email: true,
        Customer_balance: true,
        Shipping_type: true,
        Customer_number: true,
      },
      bill_to: {
        Name: true,
        Phone_no: true,
        Address: true,
      },
      ship_to: {
        Name: true,
        Phone_no: true,
        Address: true,
      },
      product_details: {
        Sr_No: true,
        Image: true,
        Name: true,
        SKU: true,
        UPC_Barcode: true,
        UPC_Number: true,
        Supply_Price: true,
        Discount: true,
        Qty: true,
        Extended: true,
        Total_Without_Discount: false,
      },
      payment_detials: {
        Sr_No: true,
        Payment_Type: true,
        reference_no: true,
        Payment_Category: true,
        Payment_Date: true,
        Amount: true,
        Is_Cleared: true,
      },
      total_amount_details: {
        Total_Products: true,
        Total_Quantity: true,
        Sub_Total: true,
        Returned_Quantity: true,
        Amount_Returned: true,
        Coupon_Discount: true,
        Other_Discount: true,
        Discount_Amount: true,
        Delivery_Charges: true,
        Tax: true,
        Total: true,
        On_Account: true,
        Paid_Amount: true,
        Previous_Balance: true,
      },
    },
    POS: {
      tax_type: 1,
      tax: 0.0, // 5.0
      is_stripe_enabled: false,
      stripe_public_key: "default",
      stripe_secret_key: "default",
      attributes: [],
    },
    TAX: {
      tenant_tax_applicable: false,
    },
    Email: {},
    SALE_SETTING: {},
    IMMUTABLE_BASIC: {
      ecom_url: "",
      portal_url: "",
    },
    CometChat: {
      is_active: false,
      app_id: null,
      region: "us",
      api_key: null,
    },
    type: "admin-panel",
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const basicSettingsSlice = createSlice({
  name: "basicSettings",
  initialState: initialBasicSettingsState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error?.constructor?.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    startLoading: (state, action) => {
      state.error = null;
      state.devicesListLoading = true;
    },
    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    updateCurrencySymbol: (state, action) => {
      state.entity = action.payload?.entity;
      state.message.success = "Settings Updated";
      state.actionsLoading = false;
    },

    updateBasicSettings: (state, action) => {
      state.entity.Basic = action.payload?.entity;
      state.message.success = "Settings Updated";
      state.actionsLoading = false;
    },

    updateTaxSettings: (state, action) => {
      state.entity.TAX = action.payload.entity
      state.message.success = "Settings Updated";
      state.actionsLoading = false;
    },

    updateInvoiceToggleSettings: (state, action) => {
      state.entity.Invoice = action.payload?.entity["admin-panel"]?.["pos_invoice"] || action.payload?.entity || { ...state.entity.Invoice };
      state.actionsLoading = false;
    },

    updatePOSSettings: (state, action) => {
      state.entity.POS = action.payload?.entity;
      state.message.success = "Settings Updated";
      state.actionsLoading = false;
    },

    updateMSASettings: (state, action) => {
      state.entity.MSA = action.payload?.entity;
      state.message.success = "Settings Updated";
      state.actionsLoading = false;
    },

    updateEmailSettings: (state, action) => {
      state.entity.Email = action.payload?.entity;
      state.message.success = "Settings Updated";
      state.actionsLoading = false;
    },
    updateDeliveryModuleSettings: (state, action) => {
      state.entity.DELIVERY = action.payload;
    },

    updateShippingSettings: (state, action) => {
      state.entity.SHIPPING = action.payload;
    },

    updateShipmentSettings: (state, action) => {
      state.entity.Shipment = action.payload?.entity;
      state.message.success = "Settings Updated";
      state.listLoading = false;
    },
    
    updateEamilNotificationsSettings: (state, action) => {
      state.entity.EmailNotifications = action.payload?.entity;
      state.message.success = "Settings Updated";
      state.listLoading = false;
    },

    getSettings: (state, action) => {
      const { basic, msa, email, pos, pos_invoice, immutable_basic, shipment_providers, tax, promotion_banner, delivery_module, shipping } = action.payload?.entity["admin-panel"];
      const { portal_email } = action.payload?.entity?.["email"]||{};
      const _setting = {
        MSA: msa,
        Basic: basic,
        POS: pos,
        IMMUTABLE_BASIC: immutable_basic,
        Email: email,
        Invoice: pos_invoice,
        Shipment: shipment_providers,
        TAX: tax,
        PROMOTION_BANNER: promotion_banner,
        portal_email:portal_email,
        DELIVERY: delivery_module,
        SHIPPING: shipping
      };
      state.entity = { ...state.entity, ..._setting };
      state.actionsLoading = false;
    },

    getImmutableBasicSettings: (state, action) => {
      state.entity.IMMUTABLE_BASIC = action.payload?.entity;
      state.actionsLoading = false;
    },

    getMSASettings: (state, action) => {
      state.entity.MSA = action.payload?.entity;
      state.actionsLoading = false;
    },

    getShipmentSettings: (state, action) => {
      state.entity.Shipment = action.payload?.entity;
      state.actionsLoading = false;
    },

    getBasicSettings: (state, action) => {
      state.entity.Basic = action.payload?.entity?.["admin-panel"].basic || action.payload?.entity;
      state.actionsLoading = false;
    },

    getEmailSettings: (state, action) => {
      state.entity.Email = action.payload?.entity;
      state.actionsLoading = false;
    },

    ProductSOsettingListing: (state, action) => {
      state.entity.SALE_SETTING = action.payload?.entity;
      state.actionsLoading = false;
    },

    getPOSSettings: (state, action) => {
      state.entity.POS = action.payload?.entity?.["admin-panel"].pos || action.payload?.entity;
      state.actionsLoading = false;
    },

    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },

    DragColumnListing: (state, action) => {
      const { entity, columns } = action.payload;
      state.dragcolumnlisting = entity?.selectedColumns ? entity : { selectedColumns: columns };
      state.actionsLoading = false;
      state.listLoading = false;
    },

    productListingColumnOrder: (state, action) => {
      const { entity, columns } = action.payload;
      state.catalogProductColumnOrder = entity?.selectedColumns ? entity : { selectedColumns: columns };

      state.actionsLoading = false;
      state.listLoading = false;
    },

    DeviceListFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.devicesListLoading = false;
      state.error = null;
      state.entity.Devices.devicesListing = entities;
      state.entity.Devices.totalCount = totalCount;
    },
  },
});
